var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c(_vm.tag,{tag:"component",staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }